var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"toastComm",class:['toast_comm', `toast_${_vm.getIsToastData.toastType}`, { active : _vm.getIsToastPopup && _vm.isActive && _vm.getIsToastData.toastMsg && _vm.getIsToastData.toastType }]},[_c('div',{staticClass:"inner_toast"},[_c('p',{staticClass:"desc_message",domProps:{"innerHTML":_vm._s(_vm.getIsToastData.toastMsg)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }